import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';
import { safeStorage } from '../lib/safeStorage';

function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = safeStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    safeStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    safeStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-4 md:max-w-md bg-white border-2 border-zinc-950 rounded-md shadow-lg z-50 p-4" data-testid="cookie-banner">
      <button
        onClick={declineCookies}
        className="absolute top-2 right-2 text-zinc-400 hover:text-zinc-600"
        aria-label="Close"
      >
        <X className="w-4 h-4" />
      </button>
      
      <h3 className="text-sm font-bold text-zinc-950 uppercase tracking-wider mb-2">Cookie Notice</h3>
      <p className="text-xs text-zinc-700 leading-relaxed mb-4">
        We use essential cookies to ensure the app functions correctly and securely. We also use cookies to:
        <br />• Keep you logged in
        <br />• Remember your preferences
        <br />• Protect your data with encryption
        <br /><br />
        We do NOT use tracking or advertising cookies. Your data is private and secure.
      </p>
      
      <div className="flex space-x-2">
        <Button
          onClick={acceptCookies}
          className="flex-1 bg-zinc-950 text-white hover:bg-zinc-800 rounded-md h-10 text-xs uppercase"
          data-testid="accept-cookies-btn"
        >
          Accept
        </Button>
        <Button
          onClick={declineCookies}
          variant="outline"
          className="flex-1 h-10 text-xs uppercase"
          data-testid="decline-cookies-btn"
        >
          Decline
        </Button>
      </div>
    </div>
  );
}

export default CookieBanner;